import { ChecklistTemplate } from './types';

/**
 * Plantilla de revisión para ALUMBRADO DE EMERGENCIA Y SEÑALIZACIÓN.
 *
 * Referencias normativas:
 *   - RD 513/2017 (RIPCI), Anexo II.
 *   - CTE DB-SUA 4 · DB-SI 3 (señalización e iluminación).
 *   - REBT ITC-BT-28 (locales de pública concurrencia).
 *   - UNE-EN 1838 (alumbrado de emergencia: niveles ≥1 lux ruta evacuación, ≥5 lux puntos críticos).
 *   - UNE 23035 (señales fotoluminiscentes).
 *
 * Periodicidad: T = Trimestral · A = Anual.
 */
export const ALUMBRADO_SENALIZACION_TEMPLATE: ChecklistTemplate = {
  tipo_sistema: 'pci_alumbrado_senalizacion',
  titulo: 'Alumbrado de emergencia y señalización',
  protocolos: [
    {
      id: 'inventario',
      titulo: '1. Inventario y configuración general',
      cabecera: [
        { key: 'num_luminarias', label: 'Nº total de luminarias de emergencia', tipo: 'number' },
        { key: 'num_senales', label: 'Nº total de señales', tipo: 'number' },
        { key: 'recorridos', label: 'Nº de recorridos de evacuación' },
      ],
      preguntas: [
        { id: 'IN.01', texto: '¿El inventario físico coincide con planos de evacuación y proyecto?', periodicidad: ['A'] },
        { id: 'IN.02', texto: '¿La cobertura del alumbrado garantiza ≥1 lux en ruta y ≥5 lux en puntos críticos (UNE-EN 1838)?', periodicidad: ['A'] },
        { id: 'IN.03', texto: '¿Las salidas, recorridos y equipos PCI disponen de señalización conforme a UNE 23033 / 23034 / 23035?', periodicidad: ['A'] },
      ],
    },
    {
      id: 'alumbrado',
      titulo: '2. Luminarias de alumbrado de emergencia',
      cabecera: [
        { key: 'planta', label: 'Planta' },
        { key: 'ubicacion', label: 'Ubicación' },
        { key: 'marca', label: 'Marca' },
        { key: 'modelo', label: 'Modelo' },
        { key: 'lumenes', label: 'Lúmenes' },
        { key: 'autonomia_h', label: 'Autonomía (h)' },
        { key: 'permanente', label: 'Permanente / No permanente' },
      ],
      preguntas: [
        { id: 'AL.01', texto: '¿El piloto / LED de carga está encendido (red presente, batería en carga)?', periodicidad: ['T','A'], unidades: true },
        { id: 'AL.02', texto: '¿La luminaria está libre de polvo, suciedad y daños en el difusor?', periodicidad: ['T','A'], unidades: true },
        { id: 'AL.03', texto: '¿Al simular fallo de red, la luminaria enciende correctamente y sin parpadeos?', periodicidad: ['T','A'], unidades: true },
        { id: 'AL.04', texto: '¿La autonomía mínima de 1 h se mantiene tras la prueba de descarga?', periodicidad: ['A'], unidades: true },
        { id: 'AL.05', texto: '¿La luminaria está libre de obstáculos que reduzcan el haz lumínico?', periodicidad: ['T','A'], unidades: true },
        { id: 'AL.06', texto: '¿El estado general (fijación, cableado, conexiones) es correcto?', periodicidad: ['A'], unidades: true },
        { id: 'AL.07', texto: '¿La fecha de baterías está vigente (≤ 4 años) o se ha planificado su sustitución?', periodicidad: ['A'], unidades: true },
      ],
    },
    {
      id: 'senalizacion',
      titulo: '3. Señalización de evacuación y equipos PCI',
      cabecera: [
        { key: 'planta', label: 'Planta' },
        { key: 'ubicacion', label: 'Ubicación' },
        { key: 'senal_tipo', label: 'Tipo (Salida / Equipo PCI / Prohibición / Obligación)' },
        { key: 'pictograma', label: 'Pictograma' },
      ],
      preguntas: [
        { id: 'SE.01', texto: '¿La señal está visible, legible y libre de obstáculos / mobiliario?', periodicidad: ['T','A'], unidades: true },
        { id: 'SE.02', texto: '¿El pictograma se corresponde con la norma (UNE 23033 / 23034 / EN ISO 7010)?', periodicidad: ['A'], unidades: true },
        { id: 'SE.03', texto: '¿Las señales fotoluminiscentes mantienen su capacidad de emisión (UNE 23035)?', periodicidad: ['A'], unidades: true },
        { id: 'SE.04', texto: '¿La señal está bien fijada y en posición que permite verla desde el recorrido de evacuación?', periodicidad: ['T','A'], unidades: true },
        { id: 'SE.05', texto: '¿Cada equipo PCI (extintor, BIE, pulsador, etc.) dispone de su señal identificativa?', periodicidad: ['A'] },
      ],
    },
    {
      id: 'pruebas',
      titulo: '4. Pruebas funcionales del conjunto',
      preguntas: [
        { id: 'PR.01', texto: '¿Se ha realizado prueba de corte de tensión general comprobando encendido de todas las luminarias?', periodicidad: ['A'] },
        { id: 'PR.02', texto: '¿Se ha medido nivel de iluminancia en ruta y puntos críticos (≥ 1 lux / ≥ 5 lux)?', periodicidad: ['A'] },
        { id: 'PR.03', texto: '¿Se han detectado y sustituido luminarias / baterías defectuosas tras la prueba?', periodicidad: ['A'] },
      ],
    },
    {
      id: 'documentacion',
      titulo: '5. Documentación y registros',
      preguntas: [
        { id: 'DC.01', texto: '¿Existe acta firmada de la última revisión por empresa mantenedora habilitada?', periodicidad: ['A'] },
        { id: 'DC.02', texto: '¿Está actualizado el inventario con marca, modelo, lúmenes, autonomía y ubicación?', periodicidad: ['A'] },
        { id: 'DC.03', texto: '¿Los planos de evacuación están actualizados y colocados en zonas comunes?', periodicidad: ['A'] },
        { id: 'DC.04', texto: '¿Se ha entregado al titular el informe de anomalías y acciones correctoras?', periodicidad: ['A'] },
      ],
    },
  ],
};
